import React, { Component } from "react";
import { Progress } from 'antd';

import firebase from "firebase";
import FileUploader from "react-firebase-file-uploader";

class ImageUploader extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      avatar: props.avatar,
      isUploading: false,
      progress: 0,
      avatarURL: '',
    };
  };
  

  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = progress => this.setState({ progress });

  handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };

  handleUploadSuccess = filename => {
    const { file } = this.state

    this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("images")
      .child(filename)
      .getDownloadURL()
      .then(url => {
        this.setState({ avatarURL: url })
        this.props.onUploadPicture({
          type: 'success',
          imageUrl: url,
          filename: file.name
        });
      });
  };

  renderLoadingBar = () => {
    const { isUploading, progress } = this.state

    return (
      <div className="loading-bar">
        { isUploading && <Progress percent={progress} status="active" /> }
      </div>
    );
  }

  renderFileUploader = () => (
    <FileUploader
      hidden
      accept="image/*"
      name="avatar"
      filename={file => {
        this.setState({ file })
        return `${Math.random()}`;
      }}
      storageRef={firebase.storage().ref("images")}
      onUploadStart={this.handleUploadStart}
      onUploadError={this.handleUploadError}
      onUploadSuccess={this.handleUploadSuccess}
      onProgress={this.handleProgress}
    />
  );


  renderFileUploaderLabel = () => (
    <label className='btn info'>
      <i className="fas fa-upload" />
      <span className="margin-left">
        Upload Picture
      </span>
      {this.renderFileUploader()}
    </label>
  );

  render() {

    return (
      <div className='upload-picture'>
        {this.renderFileUploaderLabel()}
        {this.renderLoadingBar()}
      </div>
    );
  }
}

export default ImageUploader;
